import { useEffect, useState } from "react";
import { Loader2, Megaphone, Send } from "lucide-react";

const field = "bg-black border border-[#2a2f3d] px-3 py-2 text-sm focus:border-[#ff6a3d] outline-none";
const errText = (e) => (typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Something went wrong.");

export function AdminAnnounce({ admin, me }) {
  const [st, setSt] = useState(null);
  const [to, setTo] = useState(me || "");
  const [tested, setTested] = useState(false);
  const [busy, setBusy] = useState(null);
  const [msg, setMsg] = useState(null);
  const load = () => admin.get("/announce/texture-grain").then((r) => setSt(r.data)).catch(() => setSt(null));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const test = async () => {
    setBusy("test"); setMsg(null);
    try { await admin.post("/announce/texture-grain/test", { email: to.trim() }); setTested(true); setMsg(`Test sent to ${to.trim()}. Check it, then send to everyone.`); }
    catch (x) { setMsg(errText(x)); }
    setBusy(null);
  };
  const sendAll = async () => {
    if (!window.confirm(`Send the grain update email to ${st?.pending} Texture buyers? Each person gets it once.`)) return;
    setBusy("send"); setMsg(null);
    try { await admin.post("/announce/texture-grain/send"); setMsg("Sending now. The counts update as emails go out."); setTimeout(load, 4000); }
    catch (x) { setMsg(errText(x)); }
    setBusy(null);
  };
  return (
    <section className="border border-[#ff6a3d]/60 bg-[#0e1013] p-4 space-y-3" data-testid="admin-announce">
      <div className="flex flex-wrap items-center gap-3">
        <h2 className="font-display uppercase text-2xl flex items-center gap-2"><Megaphone size={18} className="text-[#ff6a3d]" /> Texture grain update email</h2>
        {st && <span className="font-mono text-xs text-[#9ba3b4]" data-testid="admin-announce-counts">{st.recipients} Texture buyers · {st.sent} sent · {st.pending} to send{st.failed ? ` · ${st.failed} failed` : ""}</span>}
      </div>
      <div className="flex flex-wrap gap-2 items-center">
        <input className={`${field} w-72`} type="email" value={to} onChange={(e) => setTo(e.target.value)} placeholder="your@email.com" data-testid="admin-announce-test-email" />
        <button onClick={test} disabled={!!busy || !to.trim()} className="btn-ghost px-4 py-2 text-sm flex items-center gap-2" data-testid="admin-announce-test-btn">
          {busy === "test" ? <Loader2 size={14} className="spin" /> : <Send size={14} />} Send me a test
        </button>
        <button onClick={sendAll} disabled={!!busy || !tested || !st?.pending} className="px-4 py-2 text-sm font-semibold text-black bg-[#ff6a3d] hover:opacity-85 disabled:opacity-40 transition-opacity flex items-center gap-2" data-testid="admin-announce-send-btn">
          {busy === "send" && <Loader2 size={14} className="spin" />} Send to all Texture buyers
        </button>
      </div>
      <p className="text-xs text-[#5c6479]">Send a test first to unlock the button. Paid Texture licences only (including the Finishing Suite); anyone already emailed is skipped.</p>
      {msg && <div className="text-sm text-[#c9ced8]" data-testid="admin-announce-msg">{msg}</div>}
    </section>
  );
}
